import { AbsolutePath } from "@kform/core";

/** Error occurring at a certain path. */
export class AtPathError extends Error {
  /** Path at which the error occurred. */
  public readonly path: AbsolutePath;

  constructor(path: AbsolutePath, message: string, options?: ErrorOptions) {
    super(`At '${path.toString()}': ${message}`, options);
    this.name = this.constructor.name;
    this.path = path;
  }
}

/** Error thrown when an invalid {@link AtPathError.path path} was provided. */
export class InvalidPathError extends AtPathError {
  constructor(path: AbsolutePath, message: string) {
    super(path, message);
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when attempting to access the context of a form when no form is
 * in context.
 */
export class NoFormContextError extends Error {
  constructor() {
    super("No form context found");
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when attempting to access a form value but no form is in context
 * and no form manager was provided via an option.
 */
export class NoFormManagerError extends Error {
  constructor() {
    super("No form manager found");
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when attempting to access the controller of a form but no form
 * controller is in context.
 */
export class NoFormControllerError extends Error {
  constructor() {
    super("No form controller found");
    this.name = this.constructor.name;
  }
}
